import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const AsyncDiscoverSection = lazyForPaint(() =>
	import(
		/* webpackChunkName: "async-app-menu-recommended-apps" */ './discover-section/DiscoverSection.tsx'
	).then((module) => module.DiscoverSection),
);
